<div
	class="brand-kit-color-picker"
	*ngIf="kitState$ | async as state"
	(mousedown)="$event.preventDefault()"
	(click)="$event.stopPropagation()"
>

	<!-- Loading state -->
	<div *ngIf="state.loading" class="loading-state">
		<mat-spinner diameter="16"></mat-spinner>
		<span i18n="@@brandKitColorPickerLoading">Loading brand kits...</span>
	</div>

	<!-- Error state -->
	<div *ngIf="state.error" class="error-state">
		<span>{{ state.error }}</span>
		<button mat-button (click)="onRetry(); $event.stopPropagation()" i18n="@@brandKitColorPickerRetry">Retry</button>
	</div>

	<!-- Content (only if kits available) -->
	<ng-container *ngIf="!state.loading && !state.error && state.kits.length > 0">

		<!-- Kit Selector Dropdown -->
		<div class="kit-selector">
			<button class="dropdown-trigger"
					(click)="toggleDropdown(); $event.stopPropagation()"
					type="button">
				<span class="trigger-text">{{ getSelectedKitName(state.kits) }}</span>
				<mat-icon class="dropdown-arrow" [class.open]="isDropdownOpen">expand_more</mat-icon>
			</button>

			<div class="dropdown-options" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
				<button *ngFor="let kit of state.kits"
						class="dropdown-option"
						[class.selected]="(selectedKitId$ | async) === kit.id"
						(click)="selectKit(kit.id); $event.stopPropagation()"
						type="button">
					<span class="kit-name">{{ kit.name }}</span>
					<div class="color-previews">
						<span *ngFor="let color of getPreviewColors(kit)"
							  class="color-dot"
							  [style.background-color]="color.value"
							  [attr.aria-label]="color.name">
						</span>
					</div>
				</button>
			</div>
		</div>

		<!-- Color Swatches -->
		<div class="colors-section" *ngIf="brandKitColors$ | async as colors">
			<div class="title" i18n="@@brandKitColorPickerColorsTitle">Brand Kit Colors</div>
			<div class="colors">
				<div *ngFor="let color of colors"
					 class="color-item"
					 [class.selected]="isColorSelected(color)"
					 [style.background-color]="color.value"
					 [matTooltip]="(color?.label || '') + (color.label ? ' (' + color.value + ')' : color.value)"
					 (click)="onColorClick(color); $event.stopPropagation()">
				</div>
			</div>
		</div>

	</ng-container>
</div>
